// extracted by mini-css-extract-plugin
export var AiDevSuccesStories = "style-module--AiDevSuccesStories--80c71";
export var AiDevSuccesStoriesHeading = "style-module--AiDevSuccesStoriesHeading--810cc";
export var Aileftcircle = "style-module--Aileftcircle--d175d";
export var SuccessStories = "style-module--SuccessStories--eba2f";
export var SuccessStoriesAnim = "style-module--SuccessStoriesAnim--9532e";
export var cardImg = "style-module--cardImg--8c517";
export var categoriesSelection = "style-module--categoriesSelection--feda5";
export var companyReview = "style-module--companyReview--666e2";
export var companySiteInfo = "style-module--companySiteInfo--1bcde";
export var container = "style-module--container--863dc";
export var data_col = "style-module--data_col--1900c";
export var data_row = "style-module--data_row--8f793";
export var heading = "style-module--heading--2112d";
export var heading_container = "style-module--heading_container--bd0aa";
export var homeSuccessSection = "style-module--homeSuccessSection--434a1";
export var image = "style-module--image--27f9a";
export var img_col = "style-module--img_col--1daf5";
export var nftMarketContainer = "style-module--nftMarketContainer--237ae";
export var nftMarketImg_col = "style-module--nftMarketImg_col--d8e83";
export var nftMarketPlaceHeading = "style-module--nftMarketPlaceHeading--48d43";
export var nftMarketSuccessStories = "style-module--nftMarketSuccessStories--4f9e1";
export var nftMarkettabSuccessStories = "style-module--nftMarkettabSuccessStories--99af6";
export var pricingSuccessSection = "style-module--pricingSuccessSection--7b577";
export var rightCircle = "style-module--rightCircle--38241";
export var rightGreenCircle = "style-module--rightGreenCircle--b2a35";
export var row = "style-module--row--ab4bb";
export var sliderWrapper = "style-module--sliderWrapper--dc458";
export var swiperBtn = "style-module--swiperBtn--39a20";
export var swiperBtnWrapper = "style-module--swiperBtnWrapper--97feb";
export var tabSuccessStories = "style-module--tabSuccessStories--3a5fb";
export var tokenSuccessSection = "style-module--tokenSuccessSection--1816b";
export var web3SuccessHeading = "style-module--web3SuccessHeading--09223";